
const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Solicitações de Câmbio',
    to: 'solicitacaoCambioList'
  }
]

export default [
  {
    path: '/solicitacaoCambio',
    name: 'solicitacaoCambioList',
    component: () => import('@/views/SolicitacaoCambio/SolicitacaoCambioListPage.vue'),
    meta: {
      title: 'Solicitações de Câmbio',
      breadcrumb: breadCrumb
    },
  },
  {
    path: '/solicitacaoCambio/novo',
    name: 'NovaSolicitacaoCambio',
    component: () => import('@/views/SolicitacaoCambio/SolicitacaoCambioFormPage.vue'),
    meta: {
      title: 'Nova Solicitação de Câmbio',
      breadcrumb: [
        ...breadCrumb,
        {
          label: 'Nova Solicitação de Câmbio',
          to: 'NovaSolicitacaoCambio'
        }
      ]
    }
  },
  {
    path: '/solicitacaoCambio/:id/edit',
    name: 'SolicitacaoCambioEdit',
    component: () => import('@/views/SolicitacaoCambio/SolicitacaoCambioFormPage.vue'),
    meta: {
      title: 'Solicitação de Câmbio',
      breadcrumb: [
        ...breadCrumb,
      {
          label: 'Solicitação de Câmbio',
          to: 'NovaSolicitacaoCambio'
        }
      ]
    }
  },
  {
    path: '/solicitacaoCambio/:id/view',
    name: 'SolicitacaoCambioView',
    component: () => import('@/views/SolicitacaoCambio/SolicitacaoCambioFormPage.vue'),
    meta: {
      title: 'Solicitação de Câmbio',
      breadcrumb: [
        ...breadCrumb,
      {
          label: 'Solicitação de Câmbio',
          to: 'NovaSolicitacaoCambio'
        }
      ]
    }
  },
];